import React, {Component} from 'react';
import $ from 'jquery';
import './App.css';
import './RedesignGlobal.css';

import { BrowserRouter as Router } from "react-router-dom";
import { Switch, Route, Routes } from "react-router-dom";
import About from './Components/about';
import IndexComponent from './Components/index';



import AmelioratedHome from './Components/AmelioratedHome'



import Navbar from './Components/Navbar';
import ServicesAmeliorated from './Components/ServicesAmeliorated'
import ContactUs from './Components/ContactUs';
import { Navigate, Link } from 'react-router-dom';

import { withTranslation } from 'react-i18next';



import './i18n';

 class App extends Component {
  
  constructor(props) {
    super(props)
  
    this.state = {
       showNav: true,
       year: new Date().getFullYear()
    };
      this.toggleNav = this.toggleNav.bind(this);
  }
  toggleNav() {
    this.setState({ 
        showNav: !this.state.showNav
    })
}

classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

toggleLanguage = () => {
  const { i18n } = this.props;
  i18n.changeLanguage(i18n.language === 'en' ? 'fr' : 'en')
};
  render(){
    const {showNav} =this.state;
    const {setShowNav} =this.state;
    const { i18n } = this.props;
   
    
return(


  <Router>
     



   


  
<Navbar />

  <div className="m-0"> 
  <Routes>
        <Route path="/home" element={<IndexComponent/>} />
        <Route path="/services" element={<ServicesAmeliorated/>}/>
        <Route path="/about" element={<About/>} />
        <Route path="/contactUs" element={<ContactUs/>}/>
        <Route exact path='/' element={ <Navigate to="/home" />} />
           </Routes>
      
  </div>
  <footer className="bg-light text-center text-lg-start" >
  
  <div className="text-center p-3" style={{backgroundColor: "#343a40",color: "#B8860B"}}>
    © {this.state.year} Copyright:
    <a href="/about" style={{color: "#B8860B"}}>YBTechnicalServices.com</a>
  </div>
  
</footer>

</Router>

)

  }
 
}
export default withTranslation()(App);

